import React from "react";
export const HelpCircleIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.0467 7.50016L9.44668 8.1135C8.96668 8.5935 8.66668 9.00016 8.66668 10.0002H7.33334V9.66683C7.33334 8.92683 7.63334 8.26016 8.11334 7.78016L8.94001 6.94016C9.18668 6.70016 9.33334 6.36683 9.33334 6.00016C9.33334 5.26016 8.73334 4.66683 8.00001 4.66683C7.64639 4.66683 7.30725 4.8073 7.0572 5.05735C6.80715 5.3074 6.66668 5.64654 6.66668 6.00016H5.33334C5.33334 5.29292 5.61429 4.61464 6.11439 4.11454C6.61449 3.61445 7.29277 3.3335 8.00001 3.3335C8.70725 3.3335 9.38553 3.61445 9.88563 4.11454C10.3857 4.61464 10.6667 5.29292 10.6667 6.00016C10.6667 6.58683 10.4267 7.1135 10.0467 7.50016ZM8.66668 12.6668H7.33334V11.3335H8.66668M8.00001 1.3335C7.12453 1.3335 6.25762 1.50593 5.44879 1.84097C4.63995 2.176 3.90502 2.66706 3.28596 3.28612C2.03572 4.53636 1.33334 6.23205 1.33334 8.00016C1.33334 9.76827 2.03572 11.464 3.28596 12.7142C3.90502 13.3333 4.63995 13.8243 5.44879 14.1594C6.25762 14.4944 7.12453 14.6668 8.00001 14.6668C9.76812 14.6668 11.4638 13.9644 12.7141 12.7142C13.9643 11.464 14.6667 9.76827 14.6667 8.00016C14.6667 4.3135 11.6667 1.3335 8.00001 1.3335Z"
        fill="#E6E6DC"
      />
    </svg>
  );
};

export default HelpCircleIcon;
